'use client';

import { useState } from 'react';
import { Product } from '@/lib/supabase';
import ProductCard from './ProductCard';
import ImageModal from './ImageModal';

interface ProductGalleryProps {
  products: Product[];
}

function toPercent(value: string | null) {
  const parsed = Number(value);
  if (Number.isNaN(parsed)) return 0;
  return Math.max(0, Math.min(100, Math.round(parsed)));
}

export default function ProductGallery({ products }: ProductGalleryProps) {
  console.log('Rendering ProductGallery with products:', products);
  const [selectedProduct, setSelectedProduct] = useState<Product | null>(null);

  if (!products.length) {
    return (
      <div data-component-id="src/app/category-page/components/ProductGallery.tsx:24:6" data-component-path="src/app/category-page/components/ProductGallery.tsx" data-component-line="24" data-component-end-line="29" data-component-file="ProductGallery.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22rounded-xl%20border%20border-border%20bg-white%20p-12%20text-center%22%7D" className="rounded-xl border border-border bg-white p-12 text-center">
        <h2 data-component-id="src/app/category-page/components/ProductGallery.tsx:25:8" data-component-path="src/app/category-page/components/ProductGallery.tsx" data-component-line="25" data-component-end-line="25" data-component-file="ProductGallery.tsx" data-component-name="h2" data-component-content="%7B%22elementName%22%3A%22h2%22%2C%22className%22%3A%22text-xl%20font-semibold%20text-foreground%22%2C%22textContent%22%3A%22No%20products%20found%22%7D" className="text-xl font-semibold text-foreground">No products found</h2>
        <p data-component-id="src/app/category-page/components/ProductGallery.tsx:26:8" data-component-path="src/app/category-page/components/ProductGallery.tsx" data-component-line="26" data-component-end-line="28" data-component-file="ProductGallery.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22mt-2%20text-sm%20text-muted-foreground%22%2C%22textContent%22%3A%22Try%20another%20category%20to%20see%20available%20products.%22%7D" className="mt-2 text-sm text-muted-foreground">
          Try another category to see available products.
        </p>
      </div>
    );
  }

  return (
    <>
      <div data-component-id="src/app/category-page/components/ProductGallery.tsx:35:6" data-component-path="src/app/category-page/components/ProductGallery.tsx" data-component-line="35" data-component-end-line="49" data-component-file="ProductGallery.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22grid%20grid-cols-1%20md%3Agrid-cols-2%20lg%3Agrid-cols-3%20gap-8%22%7D" className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {products.map((product) => (
          <ProductCard data-component-id="src/app/category-page/components/ProductGallery.tsx:37:10" data-component-path="src/app/category-page/components/ProductGallery.tsx" data-component-line="37" data-component-end-line="47" data-component-file="ProductGallery.tsx" data-component-name="ProductCard" data-component-content="%7B%22elementName%22%3A%22ProductCard%22%7D"
            key={product.id}
            id={product.id}
            name={product.name}
            image={product.image_url || '/assets/images/no_image.png'}
            alt={product.name}
            color={product.color_hex || product.color || '#d1d5db'}
            lightFiltering={toPercent(product.fastness_to_light)}
            material={product.material || 'N/A'}
            onClick={() => setSelectedProduct(product)}
          />
        ))}
      </div>

      {selectedProduct && (
        <ImageModal data-component-id="src/app/category-page/components/ProductGallery.tsx:52:8" data-component-path="src/app/category-page/components/ProductGallery.tsx" data-component-line="52" data-component-end-line="52" data-component-file="ProductGallery.tsx" data-component-name="ImageModal" data-component-content="%7B%22elementName%22%3A%22ImageModal%22%7D" product={selectedProduct} onClose={() => setSelectedProduct(null)} />
      )}
    </>
  );
}
